<template>
  <v-container fluid tag="section">
    <div class="order" v-if="item.again === 1">
      <img :src="require('@/assets/images/order.png')"/>
    </div>
    <v-row v-if="bookkeeping">
      <v-col class="red--text">具体开始时间和服务时长请查看合同订单【签订项目】【服务时长】字段</v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        紧急程度：<v-chip small dark :color="item.urgentLevelId | formatOrderColor">{{item.urgentLevelDic.name}}</v-chip>
      </v-col>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        主负责人：
          <v-chip v-for="(item, idx) in item.firstPersonList" small class="mr-1" outlined :key="idx">
            {{item.name}}
          </v-chip>
      </v-col>
      <v-col cols="12" :md='mini ? 6 : 4' :class="$isMobile ? 'size-13' : ''">
        协同人员 ：
        <v-chip v-for="(item, idx) in item.assistPersonList" small class="mr-1" outlined :key="idx">
          {{item.name}}
        </v-chip>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        知产用途 ：
        <v-chip v-for="(item, idx) in item.purposeList" small class="mr-1" outlined :key="idx">
          {{item.name}}
        </v-chip>
      </v-col>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        创建时间：<span class="font-weight-black">{{item.createTime | formatDay}}</span>
      </v-col>
      <v-col cols="12" :md='mini ? 6 : 4' :class="$isMobile ? 'size-13' : ''">
        实施时间：<span class="font-weight-black">{{item.startTime | formatDay}}</span>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        工单编号：<span class="font-weight-black">{{item.orderNumber}}</span>
      </v-col>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        产品名称：<span class="font-weight-black">{{item.product.name}}</span>
        <span class="font-weight-black red--text" v-if="item.years">
          ({{item.years}})
        </span>
      </v-col>
      <v-col cols="12" :md='mini ? 6 : 4' :class="$isMobile ? 'size-13' : ''">
        产品数量：<span class="font-weight-black">{{item.contract.productNumber}}</span>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        客户名称：<span class="font-weight-black">{{item.customer.name}}</span>
      </v-col>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        联系方式：
        <v-chip v-for="(item, idx) in item.allContactsPersons" small class="mr-1" outlined :key="idx">
          {{item.name}}｜{{item.phoneNumber}}
        </v-chip>
      </v-col>
      <v-col v-if="item.patent" cols="12" :md='mini ? 3 : 4'  :class="$isMobile ? 'size-13' : ''">
        交底材料：<span class="font-weight-black">{{item.patent.haveData === 1 ? '有' : '无'}}</span>
      </v-col>
    </v-row>
    <v-row v-if="item.patent">
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        首次申请：<span class="font-weight-black">{{!item.patent.firstApply ? '--' : item.patent.firstApply === 1 ? '是' : '否'}}</span>
      </v-col>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        专利定名：
          <span class="font-weight-black">
          {{!item.patent.needName ? '--' : item.patent.needName === 1 ? '需要' : '不需要'}}
          </span>
      </v-col>
      <v-col cols="12" :md='mini ? 3 : 4' :class="$isMobile ? 'size-13' : ''">
        配合项目：<span class="font-weight-black">{{!item.patent.haveItem ? '--' : item.patent.haveItem === 1 ? '有' : '没有'}}</span>
      </v-col>
    </v-row>
    <v-row v-if="item.patent && item.patent.name">
      <v-col :class="$isMobile ? 'size-13' : ''">
        专利名称：<span class="font-weight-black">{{item.patent.name}}</span>
      </v-col>
    </v-row>
    <v-row>
       <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        客户地址：<span class="font-weight-black">{{item.customer.contactsAddress}}</span>
      </v-col>
    </v-row>
     <v-row>
      <v-col cols="12" :class="$isMobile ? 'size-13' : ''">
        工单备注：<span class="font-weight-black">{{item.remark}}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'OrderDetail',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({})
      },
      mini: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
      }
    },
    computed: {
      bookkeeping () {
        return this.$constants.ProductType.Bookkeeping.indexOf(this.item.productId) !== -1
      }
    },
  }
</script>

<style lang="scss" scoped>
.order {
  position: absolute;
  z-index: 1;
  left: 250px;
  top: 25px;
  img{
    width: 120px;
    -moz-transform: rotate(-30deg);
    -webkit-transform: rotate(-30deg);
  }
}
</style>
